import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class SvgSecurityModem extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string
    };

    static defaultProps = {
        size: 30,
        color: '#8e8e8e'
    };

    render() {
        const { color, size } = this.props;
        return (
            <svg height={size / 1.5} width={size / 1.5} viewBox="0 0 300 283.4">
                <path d="M13,232.13H287a13,13,0,0,1,13,13V283.4a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V245.11A13,13,0,0,1,13,232.13Z" fill={color} />
                <path
                    d="M150,8.3h0A109.5,109.5,0,0,0,40.5,117.8v109.5h219V117.8A109.5,109.5,0,0,0,150,8.3Zm1.82,184.51a10.72,10.72,0,1,1,10.72-10.72A10.72,10.72,0,0,1,151.82,192.81Zm10.72-32.38H141.1V92.31a10.72,10.72,0,1,1,21.44,0Z"
                    transform="translate(0 -8.3)"
                    fill={color}
                />
                <path
                    d="M209.08,75.65a6,6,0,0,1-8.29-1.6,58,58,0,0,0-48.11-25.58,6,6,0,0,1,0-11.93,69.91,69.91,0,0,1,58,30.83A6,6,0,0,1,209.08,75.65Z"
                    transform="translate(0 -8.3)"
                    fill={color}
                />
            </svg>
        );
    }
}

export default withTheme(SvgSecurityModem);



// WEBPACK FOOTER //
// ./data/common/iconsvg/SvgSecurityModem.js